import $ from 'jquery'
import DataTable from 'datatables.net-dt';

new DataTable('#manuals-table', {
    ajax: {url: '/?wc-ajax=product_manuals', dataSrc: ''},
    deferRender: true,
    paging: true,
    pageLength: 20,
    columnDefs: [
        {targets: [0], searchable: true},
    ],
    language: {
        emptyTable: "Loading...",
    },
    pagingType: 'simple_numbers',
    dom: '<"top"f>rt<"table-info"ip>',
});

$.fn.DataTable.ext.pager.numbers_length = 7

function setSearchPlaceholder() {
    const screenWidth = $(window).width();
    const placeholderText = screenWidth < 600 ? 'Search...' : 'Search by product name, model/part number, etc.';
    const dataTable = $('#manuals-table').DataTable();
    const searchInput = $('#manuals-table_filter input');

    searchInput.attr('placeholder', placeholderText);
    dataTable.search('').draw();
}

setSearchPlaceholder()
$(window).on('resize', setSearchPlaceholder);